import { RarityGem, type Rarity } from './Card.js';
import type { HandCardData } from './HandCard.js';

export type DeckEntryRowProps = {
  card: HandCardData;
  qty: number;
  onIncrement: () => void;
  onDecrement: () => void;
  onPreview: () => void;
};

const KIND_DOT: Record<string, string> = {
  player: 'bg-sky-500',
  action: 'bg-rose-500',
  weather: 'bg-cyan-500',
  stadium: 'bg-amber-500',
};

export function DeckEntryRow({
  card,
  qty,
  onIncrement,
  onDecrement,
  onPreview,
}: DeckEntryRowProps) {
  const dot = (card.kind && KIND_DOT[card.kind]) ?? 'bg-ec-bone-dim';
  const rarity = (card.rarity ?? 'common') as Rarity;

  return (
    <li className="flex items-center gap-2 rounded-md border border-ec-line bg-ec-ground px-2 py-1.5 hover:border-ec-bone">
      <span className={`h-2 w-2 shrink-0 rounded-full ${dot}`} aria-hidden="true" />
      <button
        type="button"
        onClick={onPreview}
        className="flex-1 truncate text-left text-sm text-ec-face hover:text-ec-brass"
      >
        {card.name ?? card.id ?? 'Card'}
      </button>
      <RarityGem rarity={rarity} className="shrink-0" />
      <div className="flex shrink-0 items-center gap-1 rounded-md border border-ec-line bg-ec-panel">
        <button
          type="button"
          onClick={onDecrement}
          className="px-1.5 py-0.5 text-sm text-ec-bone hover:text-ec-oxblood-2"
          aria-label={`Remove one ${card.name ?? 'card'}`}
        >
          −
        </button>
        <span className="min-w-[1.25rem] text-center text-sm font-mono text-ec-face">{qty}</span>
        <button
          type="button"
          onClick={onIncrement}
          className="px-1.5 py-0.5 text-sm text-ec-bone hover:text-ec-go"
          aria-label={`Add one ${card.name ?? 'card'}`}
        >
          +
        </button>
      </div>
    </li>
  );
}
